import { DIVISION, GARMENTUSER } from './constants';

const validateAuthForm = (data) => {
  let errors = {};

  if (!data.confvalue) {
    errors.confvalue = 'Please Select Conference';
  }

  if (!data.usercode) {
    errors.usercode = 'Please Enter User Code';
  }

  if (!data.password) {
    errors.password = 'Please Enter Password';
  } else if (data.password.length < 8) {
    errors.password = 'Password must be at least 8 characters long';
  }

  return errors;
};

function isValidEmail(email) {
  // Regular expression for basic email validation
  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return regex.test(email);
}

function isValidMobile(mobile) {
  // Regular expression for 10-digit mobile numbers
  const regex = /^\d{10}$/;
  return regex.test(mobile);
}

function isValidOTP(otp) {
  // Regular expression for 10-digit mobile numbers
  const regex = /^\d{6}$/;
  return regex.test(otp);
}

function isValidPassword(otp) {
  // Regular expression for 10-digit mobile numbers
  const regex = /^.{8,}$/;
  return regex.test(otp);
}

const validateForgotPassForm = (data) => {
  let errors = {};

  if (!data.mobile) {
    errors.mobile = 'Mobile is required';
  } else if (!isValidMobile(data.mobile)) {
    errors.mobile = 'Please enter correct mobile number';
  }

  if (!data.usercode) {
    errors.usercode = 'Usercode is required';
  }

  return errors;
};

const validateOTPVerifyForm = (data) => {
  let errors = {};

  if (!data.otp) {
    errors.otp = 'OTP is required';
  } else if (!isValidOTP(data.otp)) {
    errors.otp = 'Please enter correct OTP number';
  }

  return errors;
};

const validateResetPasswordForm = (data) => {
  let errors = {};

  if (!data.new_password) {
    errors.otp = 'OTP is required';
  } else if (!isValidPassword(data.new_password)) {
    errors.new_password = 'Please enter valid password';
  }

  return errors;
};

const validateLedgerCurrentYear = (data) => {
  let errors = {};
  if (!data.customer) {
    // errors.customer = 'Please Select Customer';
  }

  // if (!data.profitCenters) {
  //   errors.profitCenters = 'Please Select Profit Center';
  // }

  return errors;
};

// export const validatePtfileDownload = (data) => {
//   let errors = {};
//   if (!data.customer) {
//     errors.customer = 'Please Select Customer';
//   }

//   return errors;
// };

const validateSalesOrder = (data, id, confSpart) => {
  let errors = {};
  const confSpartValues = confSpart === null ? '' : confSpart.split(',').map((value) => parseInt(value.trim(), 10));
  if (!data.customer) {
    errors.customer = 'Please Select Customer';
  } else {
    if (id.includes(GARMENTUSER)) {
      if (!data.distributor) {
        errors.distributor = 'Please Select Distributor';
      }
    } else {
      if (!data.retailer && !confSpartValues.includes(DIVISION)) {
        errors.retailer = 'Please Enter Retailer Name';
      }
    }
  }
  return errors;
};
const validateSalesRetriveOrder = (data) => {
  let errors = {};
  if (!data.customer) {
    errors.customer = 'Please Select Customer';
  }
  return errors;
};

const validateDeliveryFormData = (formData) => {
  // console.log("formData",formData);
  const errors = {};
  if (formData.dispatchReason === '') {
    errors.dispatchReason = 'Please select Order reason';
  }
  if (formData.name.trim() === '') {
    errors.name = 'Please enter name';
  }
  if (formData.mobile.trim() === '') {
    errors.mobile = 'Please enter mobile number';
  } else if (!/^\d{10}$/.test(formData.mobile.trim())) {
    errors.mobile = 'Please enter correct mobile number';
  }

  if (formData.email.trim() === '') {
    return errors;
  } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
    // If email has a value but is not valid
    errors.email = 'Please enter a valid email address';
  }
  return errors;
};

const validateFabricCheckout = (formData) => {
  const errors = {};
  if (!formData.dispatchMonth) {
    errors.dispatchMonth = 'Please Select Dispatch Month';
  }

  if (!formData.dispatchReason) {
    errors.dispatchReason = 'Please Select Dispatch Reason';
  }

  if (!formData.sampleRequired) {
    errors.sampleRequired = 'Please Select Sample Required';
  }

  if (formData.emailId.trim() === '') {
    return errors;
  } else if (!/\S+@\S+\.\S+/.test(formData.emailId)) {
    // If email has a value but is not valid
    errors.emailId = 'Please enter a valid email address';
  }

  return errors;
};

const validateCustomerProfile = (data, isSpecialConference = false) => {
  let errors = {};
  // if (data.gstInNumber) {
  //   // const gstinRegex = /^\d{2}[A-Z]{5}\d{4}[A-Z]\d[Z][A-Z\d]$/;
  //   // if (!gstinRegex.test(data.gstInNumber)) {
  //   //   errors.gstInNumber = 'Please enter a valid GSTIN Number';
  //   // }
  // }
  // else{
  //   errors.gstInNumber = 'Please Enter a GSTIN Number';
  // }

  if (!isSpecialConference && !data.gstInNumber && !data.isNotApplicable) {
    errors.gstInNumber = 'Please Enter a GSTIN Number';
  }

  if (!isSpecialConference && data.uploaded_file_gst && !data.isNotApplicable) {
    const fileName = data.uploaded_file_gst.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (fileExtension !== 'pdf') {
      errors.uploaded_file_gst = 'Please upload a PDF file';
    }

    // if(!data.gstInNumber)
    // {
    //   errors.gstInNumber = 'Please Enter a GSTIN Number';
    // }
  }

  if (!data.customerName) {
    errors.customerName = 'Please Enter Customer Name';
  }

  if (!data.address1) {
    errors.address1 = 'Please Enter Address1';
  }

  if (!data.address2) {
    errors.address2 = 'Please Enter Address2';
  }

  if (!data.pinCode) {
    errors.pinCode = 'Please Enter Pin Code';
  } else if (!/^\d{6}$/.test(data.pinCode)) {
    errors.pinCode = 'Please Enter Valid Pin Code';
  }

  if (!data.city) {
    errors.city = 'Please Select City';
  }

  if (!data.district) {
    errors.district = 'Please Select District';
  }

  if (!data.state) {
    errors.state = 'Please Select State';
  }

  if (!data.contactPersonFullName) {
    errors.contactPersonFullName = 'Please Enter Contact Person Full Name';
  }

  if (!data.mobileNo) {
    errors.mobileNo = 'Please Enter Mobile Number';
  } else if (!/^\d{10}$/.test(data.mobileNo)) {
    errors.mobileNo = 'Please Enter a Valid Mobile Number';
  }

  // if (!data.billTo) {
  //   errors.billTo = 'Please Select Bill To';
  // }

  // if (!data.payTo) {
  //   errors.payTo = 'Please Select Pay To';
  // }

  if (!data.bpType) {
    errors.bpType = 'Please Select BP Type';
  }

  if (!isSpecialConference && !data.emailAddress) {
    errors.emailAddress = 'Please Enter Email Address';
  } else if (!isSpecialConference && !isValidEmail(data.emailAddress)) {
    errors.emailAddress = 'Please Enter a Valid Email Address';
  }

  if (!isSpecialConference && !data.panNumber && data.isNotApplicable) {
    errors.panNumber = 'Please Enter a PAN Number';
  }

  if (!isSpecialConference && data.panNumber) {
    if (!/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(data.panNumber)) {
      errors.panNumber = 'Please Enter a Valid PAN Number';
    }
  }
  if (!isSpecialConference && data.panNumber && !data.uploaded_file_pan && data.isNotApplicable) {
    errors.uploaded_file_pan = 'Please upload a PAN  image';
  }

  // if (!data.aadharNumber) {
  //   errors.aadharNumber = 'Please Enter a Aadhar Number';
  // }

  if (data.aadharNumber) {
    if (data.aadharNumber.length < 14) {
      errors.aadharNumber = 'Please Enter a Valid Aadhar Number';
    }
  }

  if (data.uploaded_file_aadhar) {
    const fileName = data.uploaded_file_aadhar.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (!['jpg', 'jpeg', 'png'].includes(fileExtension)) {
      errors.uploaded_file_aadhar = 'Please upload an image file';
    }
  }

  if (!isSpecialConference && data.uploaded_file_pan && data.isNotApplicable) {
    const fileName = data.uploaded_file_pan.name;
    const fileExtension = fileName.split('.').pop().toLowerCase();
    if (!['jpg', 'jpeg', 'png'].includes(fileExtension)) {
      errors.uploaded_file_pan = 'Please upload an image file';
    }
  }

  if (!data.salesOfficerName) {
    errors.salesOfficerName = 'Please Enter Sales Officer Name';
  }

  if (!isSpecialConference && !data.agencyCode) {
    errors.agencyCode = 'Please Enter Agency Code';
  }
  
  // if (!data.division) {
  //   errors.division = 'Please Enter Division';
  // }

  if (!isSpecialConference && !data.transportName) {
    errors.transportName = 'Please Enter Transport Name';
  }

  if (!isSpecialConference && !data.courierName) {
    errors.courierName = 'Please Enter Courier Name';
  }

  if (!data.transportDestinationFrom) {
    errors.transportDestinationFrom = 'Please Select Transport Destination From';
  }

  if (!data.transportDestinationTo) {
    errors.transportDestinationTo = 'Please Enter Transport Destination To';
  }

  if (!isSpecialConference && !data.maxCaseOneLr) {
    errors.maxCaseOneLr = 'Please Select Max Case One Lr';
  }

  if (!data.customerCategory) {
    errors.customerCategory = 'Please Select Customer Category';
  }

  // if (!data.bankName) {
  //   errors.bankName = 'Please Enter Bank Name';
  // }

  // if (!data.bankAccountNumber) {
  //   errors.bankAccountNumber = 'Please Enter Bank Account Number';
  // }

  // if (!data.bankBranchAddress) {
  //   errors.bankBranchAddress = 'Please Enter Bank Branch Address';
  // }

  // if (!data.ifscCode) {
  //   errors.ifscCode = 'Please Enter IFSC Code';
  // }

  // if (!data.micrCode) {
  //   errors.micrCode = 'Please Enter MICR Code';
  // }

  return errors;
};

export {
  validateLedgerCurrentYear,
  validateAuthForm,
  validateForgotPassForm,
  validateSalesOrder,
  validateSalesRetriveOrder,
  validateDeliveryFormData,
  validateFabricCheckout,
  validateCustomerProfile,
  isValidMobile,
  validateOTPVerifyForm,
  validateResetPasswordForm
};
